/* eslint-disable max-len */
import React from 'react';
import './selectedFilterTag.scss';
import { ActionButton, Flex } from '@adobe/react-spectrum';
import Close from '@spectrum-icons/workflow/Close';
import { connect } from 'react-redux';
import { withRouter } from '../withRouter';
import { addSingleFilter, removeSingleFilter } from '../../actions/filterActions';
import { filterTagNamesMap } from '../../util/util';

function SelectedFilterTags({
  appliedFilters, facets, addSingleFilterAction, router, removeSingleFilterAction, isMobile,
}) {
  const clearFilterSelection = (filterItem, type) => {
    if (appliedFilters[type].includes(filterItem)) {
      const filteredArray = appliedFilters[type].filter((item) => item !== filterItem);
      if (filteredArray.length > 0) {
        addSingleFilterAction({ name: type, value: filteredArray }, router);
      } else {
        removeSingleFilterAction({ name: type }, router);
      }
    }
  };

  const clearToggleFilter = (type) => {
    removeSingleFilterAction({ name: type }, router);
  };

  const clearLocationFilter = (locationType, address) => {
    removeSingleFilterAction({ name: 'address' }, router);
    addSingleFilterAction({ name: 'locationType', value: 'all' }, router);
  };

  const hasAnyFilterApplied = Object.keys(filterTagNamesMap).some((item) => {
    const filterValue = appliedFilters[item];
    return Array.isArray(filterValue) ? filterValue.length > 0 : filterValue === true;
  });

  const getToggleFilterName = (filterName) => {
    switch (filterName) {
      case 'accredited-solutions':
        return 'Partner Solutions';
      case 'specialized':
        return 'Specialized';
      case 'badges':
        return 'Partner Awards';
      default:
        return '';
    }
  };

  const getLocationFilterName = (locationType, address) => {
    switch (locationType) {
      case 'all':
        return address;
      case 'physical-location':
        if (address) {
          return `Has physical location : ${address}`;
        }
        return 'Has physical location';
      case 'hqaddress':
        if (address) {
          return `Headquarters : ${address}`;
        }
        return 'Headquarters';
      default:
        return address;
    }
  };

  return (
    <Flex UNSAFE_className="filterTagsContainer" wrap>
      {hasAnyFilterApplied && !isMobile && <div style={{ fontWeight: 'bold' }}>Filtering by: </div> }
      {Object.keys(filterTagNamesMap).map((item) => {
        if (Array.isArray(appliedFilters[item]) && appliedFilters[item]?.length > 0) {
          return appliedFilters[item].map((filterItem, index) => {
            const filterObject = facets[item].options.find((facet) => facet.id === filterItem);
            return (
              <Flex key={`${filterItem}`} UNSAFE_className="selected-filter-tag">
                {filterObject.name}
                <ActionButton
                  isQuiet
                  height={isMobile ? 25 : 15}
                  onPress={() => clearFilterSelection(filterItem, item)}
                >
                  <Close />
                </ActionButton>
              </Flex>
            );
          });
        }
        if (item === 'address' && (appliedFilters.address || appliedFilters.locationType !== 'all')) {
          return (
            <Flex UNSAFE_className="selected-filter-tag">
              {getLocationFilterName(appliedFilters.locationType, appliedFilters.address)}
              <ActionButton
                isQuiet
                height={isMobile ? 25 : 15}
                onPress={() => clearLocationFilter(appliedFilters.locationType, appliedFilters.address)}
              >
                <Close />
              </ActionButton>
            </Flex>
          );
        }
        if (appliedFilters[item] === true) {
          return (
            <Flex UNSAFE_className="selected-filter-tag">
              {getToggleFilterName(item)}
              <ActionButton
                isQuiet
                height={isMobile ? 25 : 15}
                onPress={() => clearToggleFilter(item)}
              >
                <Close />
              </ActionButton>
            </Flex>
          );
        }
        return null;
      })}
    </Flex>
  );
}

const mapStateToProps = (state) => ({
  appliedFilters: state.filter.selected,
  facets: state.facets,
  isMobile: state.facets.isMobile,
});

const mapDispatchToProps = {
  addSingleFilterAction: addSingleFilter,
  removeSingleFilterAction: removeSingleFilter,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SelectedFilterTags));
